// src/features/competicao/validacaoRegistroTreino.js
//
// Validação PRÉ-SAVE do registro de treino (v3.7.3 — Bloco E), única para
// criação e edição. Junta as regras locais (duração mínima, foto) com o
// precheck do backend (modalidade elegível na competição, tickets) e devolve
// TODOS os motivos de não-pontuação de uma vez — o aviso lista tudo, não só
// o primeiro. Cada motivo aponta o campo do formulário a destacar no
// "Ver e editar".

import { prechecarCompeticao, mensagemDoMotivo } from "./competicaoApi";

export const DURACAO_MINIMA_MIN = 40;

const duracaoMinDe = (a) => {
  const m = Number(a?.duration_min) || 0;
  return m > 0 ? m : (Number(a?.duration_sec) || 0) / 60;
};

export const resumoAtividadesCliente = (atividades = []) => {
  const lista = Array.isArray(atividades) ? atividades : [];
  const duracaoMin = lista.reduce((acc, a) => acc + duracaoMinDe(a), 0);
  // FIX v3.7.3: as atividades gravam `activity_key` — ler `key` mandava a
  // modalidade como null e o backend dava o benefício da dúvida a tudo.
  const principal = [...lista].sort((x, y) => duracaoMinDe(y) - duracaoMinDe(x))[0];
  return {
    tipoAtividadeId: principal?.activity_key || principal?.key || null,
    duracaoMin,
  };
};

/**
 * Valida as regras de pontuação antes de salvar/editar o treino.
 * @param {object} p
 * @param {Array}  p.atividades  atividades do check-in
 * @param {boolean} p.temFoto    há foto (nova ou preservada da edição)
 * @param {boolean} p.compAtiva  academia com competição/verificação ligada
 * @return {Promise<{motivos: Array<{campo: string|null, mensagem: string,
 *   motivo: string}>, elegivel: boolean, tipoAtividadeId: string|null,
 *   duracaoMin: number}>}
 */
export async function validarRegrasTreino({ atividades, temFoto, compAtiva }) {
  const { tipoAtividadeId, duracaoMin } = resumoAtividadesCliente(atividades);
  const motivos = [];
  const sufixo = compAtiva ? "XP nem pontos da competição" : "XP";

  if (duracaoMin < DURACAO_MINIMA_MIN) {
    motivos.push({
      campo: "duracao",
      motivo: "DURACAO_MINIMA",
      mensagem: `Duração baixa para pontuar (${Math.round(duracaoMin)}min — ` +
        `mínimo ${DURACAO_MINIMA_MIN}min): não contabiliza ${sufixo}.`,
    });
  }
  if (!temFoto) {
    motivos.push({
      campo: "foto",
      motivo: "SEM_FOTO",
      mensagem: `Sem foto, o treino não contabiliza ${sufixo}.`,
    });
  }

  let elegivel = false;
  if (compAtiva) {
    try {
      // Duração forçada ao mínimo SÓ para o precheck: com <40min o backend
      // pararia no DURACAO_MINIMA (que já listamos localmente) e esconderia
      // problemas de modalidade/ticket — queremos listar TODOS os motivos.
      const check = await prechecarCompeticao("TREINO", {
        tipoAtividadeId,
        duracaoMin: Math.max(duracaoMin, DURACAO_MINIMA_MIN),
      });
      if (check?.elegivel) {
        elegivel = motivos.length === 0;
      } else if (!["SEM_COMPETICAO", "REGRAS_V2_DESLIGADA"].includes(check?.motivo)) {
        const jaListado = ["DURACAO_MINIMA", "SEM_FOTO"].includes(check?.motivo);
        if (!jaListado) {
          motivos.push({
            campo: check?.motivo === "TIPO_NAO_PONTUA" ? "modalidade" : null,
            motivo: check?.motivo || "INELEGIVEL",
            mensagem: mensagemDoMotivo(check?.motivo) ||
              "Este registro não pontua na competição.",
          });
        }
      }
    } catch (e) {
      // Backend indisponível: não trava o registro — segue sem precheck.
    }
  }

  return { motivos, elegivel, tipoAtividadeId, duracaoMin };
}

export default validarRegrasTreino;
